import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_SUPPPLY_CHAINS: TypedDocumentNode<Data, Variables> = gql`
  query supplyChains($workspaceId: ID!) {
    supplyChains(workspaceId: $workspaceId) {
      nodes {
        id
        name
      }
    }
  }
`
